import React from 'react'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { formatWeekLabel } from './utils'

const WeekNavigator = ({ weekRange, onPrev, onNext }) => (
  <Box display="flex" alignItems="center" justifyContent="center" px={2} py={1}>
    <IconButton aria-label="previous week" size="small" onClick={onPrev}>
      <ChevronLeftIcon />
    </IconButton>
    <Box flex={1} textAlign="center">
      <Typography variant="subtitle1">
        <Box component="span" fontWeight={500}>
          {formatWeekLabel(weekRange)}
        </Box>
      </Typography>
    </Box>
    <IconButton aria-label="next week" size="small" onClick={onNext}>
      <ChevronRightIcon />
    </IconButton>
  </Box>
)

export default WeekNavigator
